import React, { useEffect, useRef, useState } from "react";
import { BiLink, BiX } from "react-icons/bi";
import {
  PiLinkedinLogo,
  PiRedditLogo,
  PiTwitterLogo,
  PiX,
  PiXLogo,
} from "react-icons/pi";
import Modal from "react-modal";
import { toPng } from "html-to-image";
import { toast } from "react-toastify";
export default function ShareModal({ openModal, type, setModalOpen, score }) {
  const viewPort = window.innerWidth;
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "20px",
      width: `${viewPort <= 768 ? "100%" : "35%"}`,
      border: "0px",
      backgroundColor: " #ffffff",
      boxShadow: "2px 3px 6px white",
    },
  };
  const scoreRef = useRef();

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleDownload = async () => {
    try {
      const dataUrl = await toPng(scoreRef.current);
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "medipuzzle-score.png";
      link.click();
      toast.info("Score downloaded into the device");
    } catch (error) {
      console.error("Error generating image:", error);
    }
  };
  return (
    <Modal
      isOpen={openModal}
      style={customStyles}
      onRequestClose={closeModal}
      overlayClassName="modal-overlay"
    >
      <div className="text-black  d-flex flex-column gap-3 position-relative ">
        <div
          className="d-flex justify-content-between "
          style={{
            width: "100%",
            borderBottom: "1.5px solid rgba(175, 164, 164, 0.31)",
          }}
        >
          <h4
            style={{
              cursor: "pointer",
            }}
            className="text-info"
          >
            Share your score with your friends.
          </h4>
          <h3 onClick={closeModal}>
            <BiX />
          </h3>
        </div>
        <div
          ref={scoreRef}
          className="rounded-3 position-relative p-5 align-items-center d-flex flex-column gap-5 justify-content-center text-black bg-white overflow-hidden text-center"
          style={{
            backgroundColor: "rgba(224, 221, 221, 0.15)",
            boxShadow: "2px 2px 6px gray",
            height: "35vh",
            overflow: "auto",
          }}
        >
          <h3 className="text-primary">
            <span className="text-danger">Beat M</span>y Score{" "}
          </h3>

          <h5
            style={{
              color: " rgb(76, 74, 74)",
            }}
          >
            I just earned {score} LP in the{" "}
            {type === "mcq" ? "Multiple Choice Questions" : "Puzzle Game"} on
            Medipuzzle App.
          </h5>
          <button className="border-0 bg-info text-white rounded-4 p-3">
            Beat me if you can.
          </button>
          <img
            src="/images/logo2.png"
            className="position-absolute  z-0 opacity-25 object-fit-contain  h-50"
            style={{
              bottom: "67%",
              right: "80%",
            }}
            alt=""
          />
          <img
            src="/images/logo2.png"
            className="position-absolute  z-0 opacity-25 object-fit-contain  h-50"
            style={{
              top: "67%",
              right: "80%",
            }}
            alt=""
          />
          <img
            src="/images/logo2.png"
            className="position-absolute  z-0 opacity-25 object-fit-contain  h-50"
            style={{
              bottom: "67%",
              left: "80%",
            }}
            alt=""
          />
          <img
            src="/images/logo2.png"
            className="position-absolute    z-0 opacity-25 object-fit-contain  h-50"
            style={{
              top: "67%",
              left: "80%",
              rotate: "180deg",
            }}
            alt=""
          />
        </div>
        {/* <div
          style={{
            borderTop: "1.5px solid rgba(175, 164, 164, 0.31)",
          }}
          className="row pt-3   justify-content-between px-5"
        >
          <p
            className="share d-flex flex-column col-3 p-3 align-items-center gap-3"
            style={{
              cursor: "pointer",
            }}
            onClick={() => handleCopy(window.location.href)}
          >
            <BiLink size={25} className="text-black" />
            <span
              style={{
                fontSize: "",
              }}
            >
              {copied ? "Link Copied!" : "Copy Link"}
            </span>{" "}
          </p>
          <p
            className="share d-flex flex-column col-3 p-3 align-items-center gap-3"
            style={{
              cursor: "pointer",
            }}
            onClick={() => shareToX("http://localhost:3000/share.html")}
          >
            <PiXLogo size={25} className="text-black" />
            <span
              style={{
                fontSize: "",
              }}
            >
              X
            </span>{" "}
          </p>
          <p
            className="share d-flex flex-column col-3 p-3 align-items-center gap-3"
            style={{
              cursor: "pointer",
            }}
            onClick={() => shareToReddit("http://localhost:3000/share.html")}
          >
            <PiRedditLogo size={25} className="text-black" />
            <span
              style={{
                fontSize: "large",
              }}
            >
              Reddit
            </span>{" "}
          </p>
          <p
            className="share d-flex flex-column col-3 p-3 align-items-center gap-3"
            style={{
              cursor: "pointer",
            }}
            onClick={() => shareToLinkedIn("http://localhost:3000/share.html")}
          >
            <PiLinkedinLogo size={25} className="text-black" />
            <span
              style={{
                fontSize: "",
              }}
            >
              LInkedin
            </span>{" "}
          </p>
        </div> */}
        <div
          onClick={() => handleDownload()}
          className="flex justify-content-center text-info pt-2    align-items-center text-center px-3 "
          style={{
            cursor: "pointer",
          }}
        >
          <h5>
            {`<<<<`} Click anywhere to share {`>>>`}
          </h5>
        </div>
      </div>
    </Modal>
  );
}
